import React, { useEffect } from "react";
import TermsAndPolicy from "../../components/termsAndPolicy/termsAndPolicy";
import { TermsData } from "./content";

function TermsAndConditionsPage() {
  const Title = "Terms and Conditions of Use";
  const Quote = "General Terms and Conditions applicable to Use of a Web Site.";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <TermsAndPolicy
        title={Title}
        content={TermsData}
        quote={Quote}
        type="terms"
      />
    </div>
  );
}

export default TermsAndConditionsPage;
